import { lazy } from 'react';

export const SubscriptionPlansTableAsync = lazy(
 () => import('./SubscriptionPlansTable')
);
